{
	"cardTitle": "Para sua segurança, sua sessão expirou por inatividade.",
	"loginButtonLabel": "Logar novamente"
}
